import { DEFAULT_CONFIG } from '../config.js';
import { standardSizingPolicy } from '../v2/sizingPolicies.js';
/**
 * Paper-simulation-only sizing presets. Each scales V1's own quarter-Kelly
 * `kellyFraction` and `maxIndividualBuy` cap up or down from the standard
 * defaults, exactly like `confidenceScaledSizingPolicy` scales the cap in
 * `v2/sizingPolicies.ts` — nothing here changes execution, because this
 * package places no orders and holds no capital. "Aggressive" means only
 * that the hypothetical paper stake is sized more assertively.
 */
export const SIZING_PRESETS = {
    CONSERVATIVE: {
        kellyFraction: DEFAULT_CONFIG.kellyFraction * 0.5,
        maxIndividualBuy: DEFAULT_CONFIG.maxIndividualBuy * 0.5,
    },
    STANDARD: {
        kellyFraction: DEFAULT_CONFIG.kellyFraction,
        maxIndividualBuy: DEFAULT_CONFIG.maxIndividualBuy,
    },
    AGGRESSIVE: {
        kellyFraction: DEFAULT_CONFIG.kellyFraction * 1.5,
        maxIndividualBuy: DEFAULT_CONFIG.maxIndividualBuy * 1.5,
    },
};
/** Builds a `SizingPolicy` for the named preset, layered on top of whatever config the caller passes in (or `DEFAULT_CONFIG`). */
export function presetSizingPolicy(preset) {
    const overrides = SIZING_PRESETS[preset];
    return (input, config = DEFAULT_CONFIG) => standardSizingPolicy(input, { ...config, ...overrides });
}
//# sourceMappingURL=sizingPresets.js.map